//
// BIRDSchema.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./BIRDModel";

var BIRDSchema = createModule("BIRD::BIRDSchema", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        epochVersion: 4,
        majorVersion: 4,
        minorVersion: 4,
        nonce: 7,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_s: [4,7],
    },
    ,
    ["_create"]
]);
export default BIRDSchema;
